"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(props, propName, componentName) {
  var prop = props[propName];
  var validation = prop > 0 && prop <= 1;
  if (prop && !validation) {
    return new Error("Invalid prop '".concat(propName, "' of value '").concat(prop, "' supplied to '").concat(componentName, "', expected a number > 0 and <= 1"));
  }
  return null;
};